import util from '@bmp-vue/core/api/util'

const controller = 'ArquivoRetornoDetalhe'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get']))
